import { GoogleLogin, CredentialResponse } from "@react-oauth/google";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertCircle } from "lucide-react";
import { useLanguage } from "@/lib/language";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";

interface LoginProps {
  onGoogleLogin: (credential: string) => void;
  isLoading: boolean;
  error: Error | null;
}

export function Login({ onGoogleLogin, isLoading, error }: LoginProps) {
  const { t } = useLanguage();

  const handleGoogleSuccess = (credentialResponse: CredentialResponse) => {
    if (credentialResponse.credential) {
      onGoogleLogin(credentialResponse.credential);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background to-muted p-4">
      <div className="absolute top-4 right-4">
        <LanguageSwitcher />
      </div>
      <Card className="w-full max-w-md">
        <CardHeader className="space-y-1">
          <CardTitle className="text-2xl font-bold text-center">
            {t("adminPanel")}
          </CardTitle>
          <CardDescription className="text-center">
            {t("signInToManageProperties")}
          </CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col items-center gap-4">
          {error && (
            <Alert variant="destructive" className="w-full">
              <AlertCircle className="h-4 w-4" />
              <AlertDescription>
                {error.message || t("invalidCredentials")}
              </AlertDescription>
            </Alert>
          )}
          <div className={isLoading ? "opacity-50 pointer-events-none" : ""}>
            <GoogleLogin
              onSuccess={handleGoogleSuccess}
              onError={() => console.error("Google login failed")}
              useOneTap
            />
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

